const getSize = (avatarSize) => {
    switch (avatarSize) {
        case 36: {
            return 16;
        }
        case 44: {
            return 20;
        }
        case 52: {
            return 24;
        }
        case 60: {
            return 28;
        }
        default:
            return undefined;
    }
};

export { getSize };
//# sourceMappingURL=getSize.js.map
